// extracted by mini-css-extract-plugin
export default {"main":"appBody_main__8RyGx","childSection":"appBody_childSection__oFe7q","sectionHeading":"appBody_sectionHeading__hCd9y"};